if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}


setTimeout(() => {
  const mainGallery = document.querySelector('.main-gallery');
  const miniGallery = document.querySelector('.mini-gallery');

  if(mainGallery != undefined && mainGallery.children.length > 0) {
    let mainGalleryHeight = mainGallery.querySelector('li').offsetHeight;
    let miniGalleryHeight = miniGallery.offsetHeight;

    if(miniGalleryHeight > mainGalleryHeight) {
      miniGalleryHeight = miniGalleryHeight - 20;
      mainGallery.style.height = `${miniGalleryHeight}px`;
    } else {
      mainGalleryHeight = mainGalleryHeight + 20;
      mainGallery.style.height = `${mainGalleryHeight}px`;
    }
  }

}, "500");

var isInput = document.querySelector('.product-form__input-colour input:checked');
if(isInput != null && isInput != undefined) {
  const currentInput = document.querySelector('.product-form__input-colour input:checked').value;
  const galleryHoldersAll = document.querySelectorAll(".gallery-holder");
  galleryHoldersAll.forEach((holder) =>
    holder.classList.add('visually-hidden')
  );


  let galleryHolders = document.querySelector(`.gallery-holder[data-title='${currentInput}']`);
  if (galleryHolders) {
    galleryHolders.classList.remove('visually-hidden')
  }

  const mediaGalerryHolders = document.querySelectorAll(".product__media-gallery");

  mediaGalerryHolders.forEach((holder) =>
    holder.classList.add('visually-hidden')
  );

  let mediaGalerryHolder = document.querySelector(`.product__media-gallery[data-title-galley='${currentInput}']`);
  if (mediaGalerryHolder) {
    mediaGalerryHolder.classList.remove('visually-hidden')
  }


  const mainCurrentGallery = document.querySelector(`.gallery-holder[data-title='${currentInput}'] .main-gallery`);
  if(mainCurrentGallery != undefined && mainCurrentGallery.children.length > 0) {
    let mainGalleryHeight = mainCurrentGallery.querySelector('li').offsetHeight;
    mainGalleryHeight = mainGalleryHeight + 20;
    mainCurrentGallery.style.height = `${mainGalleryHeight}px`;
  }
}


var inputHolder = document.querySelectorAll('.product-form__input:not(.product-form__quantity)');
inputHolder.forEach((holder) => {
  const label = holder.querySelector('.form__label span');
  const checkerInput = holder.querySelector('input:checked');
  label.innerHTML = checkerInput.value
});


var sizeHolder = document.querySelector('.product-form__input-size') || document.querySelector('.product-form__input-amount') ;
if(sizeHolder != undefined) {
  const button = sizeHolder.querySelector('.js-size-opener')
  const checkerInput = sizeHolder.querySelector('input:checked');
  button.innerHTML = checkerInput.value
}

var sizeDrop = document.querySelector('.product-form__input-wrap');
if(sizeDrop != undefined) {
  const labels = sizeDrop.querySelectorAll('label')
  const btn = document.querySelector('.js-size-opener')

  labels.forEach((label) => {
    label.addEventListener('click', (event) => {
      const labelNext = event.target.innerText;
      sizeDrop.classList.remove('size-active')
      btn.innerHTML = labelNext
    });
  });
}



var fakeToInput = document.querySelector('input#fake-to');
var fakeFromInput = document.querySelector('input#fake-from');

var toInput = document.querySelector('input#to');
var fromInput = document.querySelector('input#from');

if(toInput != undefined && fromInput != undefined ) {
  fakeToInput.addEventListener('input', (event) => {
    const value = event.target.value;
    toInput.value = value;
  });

  fakeFromInput.addEventListener('input', (event) => {
    const value = event.target.value;
    fromInput.value = value;
  });
}

